<template>
  <b-modal
    v-model="isShow"
    @hidden="$emit('update:isShow', false)"
    @shown="openForm"
    size="md"
    id="listpay-client"
    centered
  >
    <template #modal-header="{ close }">
      <h4 class="mb-0 text-primary">
        <template>
          {{ !isEmpty(data) ? $t("ap_client_edit_payment") : $t("ap_client_add_payment") }}
        </template>
      </h4>
      <ez-icon
        icon="ezAr-icon-x"
        class="cursor-pointer"
        size="24"
        color="#114A9F"
        @click="close()"
      />
    </template>

    <FormItems
      @input-change="onInputChange"
      ref="formRef"
      :formData.sync="formData"
      :items="formItems"
    />
    <!--   <EzTable /> -->
    <template #modal-footer="">
      <LoadingButton :isLoading="isFormLoading || isFormAddLoading" @click="updatePayment">
        {{ $t("ar_common_save") }}
      </LoadingButton>
    </template>
  </b-modal>
</template>
<style lang="scss">
.dialog-class {
  width: 726px;
}
</style>
<script>
import { VoucherService } from "@/api/voucher-service";
import EzTable from "../../ultils/Table/EzTable";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";
import _ from "lodash";
import FormItems from "../../ultils/Form/FormItems.vue";

import { arClient } from "@/api/ar-client";
import {
  defineComponent,
  getCurrentInstance,
  reactive,
  toRefs,
  ref,
  watch,
  computed,
} from "@vue/composition-api";
import LoadingButton from "../../ultils/Button/LoadingButton.vue";
export default defineComponent({
  name: "ModalListPayAp",
  props: {
    isShow: Boolean,
    selectedDistribution: {
      type: Array,
      default() {
        return [];
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props, { emit, refs }) {
    const vm = getCurrentInstance().proxy;
    const formRef = ref();
    const formData = ref(
      {
        PaymentCode: "",
        PaymentDate: vm.dayjs().format("MM-DD-YYYY"),
        Amount: 0,
        SiteCode: "",
        ArDistributionAccountId: "",
      }
      /*  columns:[{}], */
    );

    const { fetchData: updatePaymentData, isLoading: isFormLoading } = useFetch(
      arClient.api_AP_UP01,
      {
        showLoading: true,
        nextFunction: () => {
          emit("refetch",props);
          emit("update:isShow", false);
        },
      }
    );
    const { fetchData: addPaymentData, isLoading: isFormAddLoading } = useFetch(
      arClient.api_AP_IP01,
      {
        showLoading: true,
        nextFunction: () => {
          emit("refetch");
          emit("update:isShow", false);
        },
      }
    );
    const formItems = computed(() => [
      {
        type: "string",
        formGroupRow: true,
        variant: "switch",
        disabled:props.data?.PaymentCode,
        formGroupClass: "m-0 mt-2",
        labelClass: "mr-3",
        name: "isAutoCreateCode",
        label: "ar_client_auto_create_code",
      },
      {
        type: "cleave",
        cleaveType: "uppercase",
        name: "PaymentCode",
        rules: { max: 13, min: 2, code: !formData.value.isAutoCreateCode },

        disabled: !_.isEmpty(props.data) || formData.value.isAutoCreateCode,
        required: !formData.value.isAutoCreateCode,
        label: "ap_client_payment_code",
        placeholder: "ap_client_payment_code",
      },
      {
        type: "date",
        name: "PaymentDate",
        disabled: true,
        label: "ar_client_created_date",
        placeholder: "ar_client_created_date",
      },
      {
        type: "cleave",
        cleaveType: "currency",

        disabled: true,
        name: "Amount",
        label: "ar_client_total_money",
        placeholder: "ar_client_total_money",
      },
      {
        type: "string",

        disabled: true,
        name: "PropertyCodeName",
        label: "ar_client_site_code",
        placeholder: "ar_client_site_code",
      },
      {
        type: "string",
        variant: "textarea",
        name: "Note",
        label: "ar_client_note",
        wrapperClass: "col-12",
      },
    ]);
    const updatePayment = async () => {
      formRef.value.validate().then(async (success) => {
        if (success) {
          const value = {
            ApPayment: {
              Note:formData.value.Note,
              AutoCode: formData.value.isAutoCreateCode,
              PaymentCode: formData.value.PaymentCode,
              PaymentDate: formData.value.PaymentDate,
              PropertyCode: formData.value.PropertyCode,
              PropertyId: formData.value.PropertyId || "F104E5F2-B68F-456A-913A-46D9E4E4A5D4",
              CurrencyCode: "VND",
              Amount: formData.value.Amount,
            },
            ArPaymentDistribution: formData.value.ArDistributionAccountId?.map((v) => ({
              ArDistributionAccountId: v,
            })),
          };

          if (!_.isEmpty(props.data)) {
            value["ApPayment"] = { ...value.ApPayment, Id: formData.value.Id };
            value["ApPaymentDistributionAcc"] = formData.value.ApPaymentDistribution.map(
              (data) => ({
                Id: data.Id,
                ArDistributionAccountId: data.ArDistributionAccountId,
              })
            );
            await updatePaymentData(value);
          } else {
            await addPaymentData(value);
          }

          emit("bv::hide::modal", "listpay-client");
        }
      });
    };
    const onInputChange = (name, v) => {
      console.log(name,v,"20444")
      if (name === "isAutoCreateCode" && !v) {
        formData.value.PaymentCode = "";
      }
    };
    const openForm = () => {
      console.log("run 2088")
      if (!_.isEmpty(props.data)) {
        formData.value = {
          ...props.data,
          isAutoCreateCode: props.data.IsAutoGeneration,
          PaymentCode:props.data.PaymentCode,
          PaymentDate: vm.dayjs().format("MM-DD-YYYY"),
          
          PropertyCodeName: `${props.data.PropertyCode} - ${props.data.PropertyName}`,
          Amount: props.data.TotalAmount,
        };
      }
      if(props.selectedDistribution.length > 0){
        
        formData.value = {
          ...formData.value,
          PropertyCodeName: `${props.selectedDistribution[0].PropertyCode} - ${props.selectedDistribution[0].PropertyName}`,
      
          PropertyId: props.selectedDistribution[0].PropertyId,
          PropertyCode: props.selectedDistribution[0].PropertyCode,
          Amount: props.selectedDistribution.reduce((acc, v) => {
            return (acc += v.Amount);
          }, 0),
          ArDistributionAccountId: props.selectedDistribution.map((v) => v.Id),
        };
      }

    };

  

    watch(
      () => formData.value.isAutoCreateCode,
      (value) => {
        if (value && !props.data.PaymentCode) {
          formData.value.PaymentCode = "";
        }
      },
      { deep: true }
    );
    return {
      onInputChange,
      formData,
      formRef,
      formItems,
      updatePayment,
      isFormLoading,
      isFormAddLoading,
      openForm,
    };
  },

  components: {
    FormItems,
    EzTable,
    LoadingButton,
  },
});
</script>
